<template>
  <div class="item-box--connected">
    <a :href="linkUrl">
      <div class="item-card--connected">
        <div class="item-card-icon--connected">
          <img :src="imageUrl" />
        </div>
        <div class="item-card-connected-info">
          <div class="item-card-connected__brand-name">
            {{ brandName }}
          </div>
          <div class="item-card-connected__item-name">
            {{ itemName }}
          </div>
          <div class="item-card-connected__item-prices">
            <span class="item-card-connected__item-price">{{ itemPrice }}</span>
            <span v-if="isIncludingTax" class="item-card-connected__item-tax">
              税込
            </span>
            <span
              v-if="hasMultipleItemSkus"
              class="item-card-connected__item-skus"
            >
              〜
            </span>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    linkUrl: {
      type: String,
      required: true
    },
    imageUrl: {
      type: String,
      required: true
    },
    brandName: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    itemPrice: {
      type: String,
      required: true
    },
    isIncludingTax: {
      type: Boolean,
      required: true
    },
    hasMultipleItemSkus: {
      type: Boolean,
      required: true
    },
    isDeliveryItem: {
      type: Boolean,
      required: true
    }
  }
}
</script>
